import { useRouter } from 'next/navigation';
import useLocale from './use-locale';

type Navigate = ((url: string) => void) & {
  prefetch: (url: string) => void;
  buildHref: (url: string) => string;
};

const useNavigate = (): Navigate => {
  const router = useRouter();
  const effectiveLocale = useLocale();

  const buildHref = (url: string) => `/${effectiveLocale}${url}`;

  const navigate = ((url: string) => router.push(buildHref(url))) as Navigate;
  navigate.prefetch = (url: string) => router.prefetch(buildHref(url));
  navigate.buildHref = buildHref;

  return navigate;
};

export default useNavigate;
